export default __webpack_public_path__ + "static/media/slide2-app.a592b671.png";